import PropTypes from 'prop-types'
import styled from 'styled-components/macro'

import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

const Box = styled.div`
  background-color: ${getToken('color-danger-light')};
  border-radius: 0;
  color: ${getToken('color-neutral-dark')};
  font-size: 10px;
  font-weight: 500;
  padding: 2px 8px;
  text-transform: uppercase;

  i {
    color: ${getToken('color-danger')};
    display: inline-block;
    font-size: 18px;
    margin-right: 5px;
    vertical-align: middle;
  }
`

export function FormAlert({ message, ...rest }) {
  if (message) {
    return (
      <Box role="alert" {...rest}>
        <span>{message}</span>
      </Box>
    )
  } else {
    return null
  }
}

FormAlert.defaultProps = {
  message: '',
  fullWidth: false,
}

FormAlert.propTypes = {
  message: PropTypes.string,
  fullWidth: PropTypes.bool,
}

export default FormAlert
